import { eq, type InitialQueryBuilder } from "@tanstack/db";

import type { TmsEvent } from "@storyboard/web-client";
import { directMembershipIdOf } from "@/models/tmsEvent/attribution";
import { store } from "@/store/store";
import type { TmsEventRow } from "@/store/types";

/** The store row for one wire event: the DTO plus the membership it is attributed to. */
export function tmsEventRowOf(event: TmsEvent): TmsEventRow {
  return { ...event, attributedMembershipId: directMembershipIdOf(event) };
}

/**
 * Upserts TMS events into the store. Events are immutable facts keyed on the anchor id, so a repeat is
 * insert-or-keep; the only column that can change is the derived attribution, which the merge recomputes.
 */
export async function bulkUpsertTmsEvent(records: readonly TmsEvent[]): Promise<void> {
  if (records.length === 0) return;
  store.upsert("tmsEvent", records.map(tmsEventRowOf));
}

/** Live query over the events attributed to one membership, for the feed and the Dispatch thread. */
export function tmsEventsForMembershipQuery(membershipId: string) {
  return (q: InitialQueryBuilder) =>
    q
      .from({ tmsEvent: store.collection("tmsEvent") })
      .where(({ tmsEvent }) => eq(tmsEvent.attributedMembershipId, membershipId));
}
